<div class="kendo-radio-container" [ngClass]="cssClass" [class.has-error]="showErrorState">
  <!-- Radio Options Container -->
  <div
    class="radio-options-container"
    [ngClass]="{
      'horizontal-layout': layout === 'horizontal',
      'vertical-layout': layout === 'vertical',
    }"
    role="radiogroup"
    [attr.aria-required]="required"
  >
    <div
      class="k-radio-wrapper"
      *ngFor="let option of options; trackBy: trackByOption"
      [ngClass]="{
        'disabled-option': option.disabled,
        'k-state-disabled': option.disabled,
      }"
    >
      <!-- Label Before -->
      <label
        *ngIf="labelPosition === 'before'"
        [for]="option.id"
        class="k-radio-label radio-label label-before"
      >
        {{ option.label }}
      </label>

      <!-- Kendo Radio Button -->
      <input
        type="radio"
        kendoRadioButton
        [id]="option.id"
        [name]="name"
        [value]="option.value"
        [checked]="option.checked"
        [disabled]="option.disabled || disabled"
        (change)="onRadioChange(option)"
        [attr.aria-label]="option.label"
        [attr.aria-checked]="option.checked"
        [attr.aria-disabled]="option.disabled || disabled"
        role="radio"
      />

      <!-- Label After (default) -->
      <label *ngIf="labelPosition === 'after'" [for]="option.id" class="k-radio-label">
        {{ option.label }}
        <span class="radio-description" *ngIf="option.description">
          {{ option.description }}
        </span>
      </label>
    </div>
  </div>

  <!-- Optional Clear Selection Button -->
  <div class="radio-actions" *ngIf="showClearButton && hasSelection()">
    <button
      kendoButton
      [size]="size"
      [disabled]="disabled"
      (click)="clearSelection()"
      class="clear-button"
      aria-label="Clear selection"
    >
      Clear Selection
    </button>
  </div>

  <!-- Helper Text Area -->
  <div class="helper-text" *ngIf="(hint && !showErrorState) || showErrorState">
    <span *ngIf="hint && !showErrorState" class="hint-text">{{ hint }}</span>
    <span *ngIf="showErrorState" class="error-text">* {{ currentErrorMessage }}</span>
  </div>
</div>
